import { TextV2, styled } from '@shared/joykit/packages';

export const ValuePropLineItem = styled(TextV2)`
  padding-top: 0.5rem;
  color: ${props => props.theme.colors.mono12};
  &:not(&:first-of-type) {
    border-top: 1px solid ${props => props.theme.colors.mono3};
  }
`;
